import { render, staticRenderFns } from "./DisplayQualificationLegend.vue?vue&type=template&id=0d30ebd3&scoped=true&"
import script from "./DisplayQualificationLegend.vue?vue&type=script&lang=ts&"
export * from "./DisplayQualificationLegend.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayQualificationLegend.vue?vue&type=style&index=0&id=0d30ebd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d30ebd3",
  null
  
)

/* custom blocks */
import block0 from "./DisplayQualificationLegend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
